/// <amd-module name="Artifacts/FeedSettings/services/FeedRecycleBinService" />

import { IFeed } from "Artifacts/Root/types";
import { getFeedClient, IFeedRestClient } from "Artifacts/Root/web-apis/RestClient/Feed";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface IFeedRecycleBinService extends IVssService {
  deleteFeed(pageContext: IVssPageContext, feed: IFeed): Promise<void>;
  restoreDeletedFeed(pageContext: IVssPageContext, feed: IFeed): Promise<void>;
  permanentDeleteFeed(pageContext: IVssPageContext, feed: IFeed): Promise<void>;
}

export class FeedRecycleBinService extends VssService implements IFeedRecycleBinService {
  public async deleteFeed(pageContext: IVssPageContext, feed: IFeed): Promise<void> {
    const feedRestClient: IFeedRestClient = getFeedClient(pageContext);
    const projectId = feed.project ? feed.project.id : undefined;

    return feedRestClient.deleteFeed(feed.id, projectId);
  }

  public async restoreDeletedFeed(pageContext: IVssPageContext, feed: IFeed): Promise<void> {
    const feedRestClient: IFeedRestClient = getFeedClient(pageContext);
    const projectId = feed.project ? feed.project.id : undefined;
    const request = <VS_Services.JsonPatchDocument>[
      {
        from: null,
        path: "/isDeleted",
        op: VS_Services.Operation.Replace,
        value: false,
      },
    ];

    return feedRestClient.restoreDeletedFeed(request, feed.id, projectId);
  }

  public async permanentDeleteFeed(pageContext: IVssPageContext, feed: IFeed): Promise<void> {
    const feedRestClient: IFeedRestClient = getFeedClient(pageContext);
    const projectId = feed.project ? feed.project.id : undefined;

    return feedRestClient.permanentDeleteFeed(feed.id, projectId);
  }
}

Services.add("IFeedRecycleBinService", { serviceFactory: FeedRecycleBinService });
